import { ModalConfirm } from "./ModalConfirm";
import { ModalConfirmWithHeader } from "./ModalConfirmWithHeader";
import { ModalSlideUp } from "./ModalSlideUp";
import { ModalWith2Buttons } from "./ModalWith2Buttons";

// also remember to register new modals in modals.ts
export const ModalsComponents = {
    ModalConfirm,
    ModalSlideUp,
    ModalWith2Buttons,
    ModalConfirmWithHeader,
} as const;
